export default __webpack_public_path__ + "8b5c1b89ba3b2a39a285a42c2815a3b4.png";